module.exports = __webpack_public_path__ + "static/media/3-audio.1e26b74.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/3-audio.wav
// module id = +HHD
// module chunks = 1